import TimesheetSummary from "../api/models/timesheetSummary";
import caseloadDisplay from '../api/models/caseloadDisplay';

/**
 * Loops through a timesheet's items and returns all of the student ids
 * that time has been logged to
 * @param timesheet TimesheetSummary
 * @returns number[]
 */
export const getStudentsFromTimesheet = (timesheet: TimesheetSummary, disciplineId: number | null = null): number[] => {
  const studentIds: number[] = [];

  //Loop through the weeks to get to the items
  if (
    timesheet !== undefined &&
    timesheet !== null &&
    timesheet.weeks !== undefined &&
    timesheet.weeks !== null
  ){
    timesheet.weeks.forEach(week => {
      if (week && week.items && Array.isArray(week.items)){
        //Loop through the items to get to the student ids
        week.items.forEach(item => {
          if (item.students && Array.isArray(item.students) && item.tasks.some(task => task.entries.some(entry => (entry.minutes ?? 0) > 0))) {
            item.students.forEach((studentId: number) => {
              if (!studentIds.find(sId => sId === studentId)) {
                studentIds.push(studentId);
              }
            });
          }
        });
      }
    });
  }

  return studentIds;
}

/**
 * Loops through a timesheet's items and returns all of the student ids
 * that time has been logged to
 * @param timesheet TimesheetSummary
 * @returns number[]
 */
export const getStudentsFromCaseloads = (caseloads: caseloadDisplay[], disciplineId: number | null = null): number[] => {
  const studentIds: number[] = [];

  //If a disciplineId is set, then filter out caseloads that are not that disciplineId
  caseloads = disciplineId === null ? caseloads : caseloads.filter((caseload: caseloadDisplay) => caseload.disciplineId === disciplineId);

  //Loop through the caseloads and get the ids
  caseloads.forEach((caseload: caseloadDisplay) => studentIds.push(caseload.studentId));

  return studentIds;
}